import React from 'react';
import { Zap, Smartphone, Leaf, TrendingUp } from 'lucide-react';

export const Stats = () => {
  const stats = [
    {
      icon: Zap,
      value: '10x',
      label: 'Faster networking',
      bgColor: 'bg-blue-100'
    },
    {
      icon: Smartphone,
      value: '99%',
      label: 'Device compatibility',
      bgColor: 'bg-purple-custom'
    },
    {
      icon: Leaf,
      value: '80%',
      label: 'Paper reduction',
      bgColor: 'bg-green-100'
    },
    {
      icon: TrendingUp,
      value: '5x',
      label: 'More engagement',
      bgColor: 'bg-coral-custom'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            Powerful Results
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Smart Connections users are already unlocking powerful results
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index}
                className={`${stat.bgColor} rounded-[2.5rem] p-8 text-center`}
              >
                <Icon className="w-12 h-12 text-navy mx-auto mb-4" />
                <div className="text-6xl font-extrabold text-navy mb-2">
                  {stat.value}
                </div>
                <p className="text-gray-700 font-semibold text-lg">
                  {stat.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
